<template>
  <div class="admin-page" @click="generalClick">
    <div class="admin-page-inner">
      <div class="admin-page-header">
        <div class="admin-page-heading">
          <button
            type="button"
            class="admin-button--secondary admin-button--sm"
            @click="$router.push({ name: 'AdminData' })"
          >
            <i class="fa fa-arrow-left mr-2" aria-hidden="true"></i>Zurück
          </button>
          <div>
            <span class="admin-kicker">Datenverwaltung</span>
            <h1 class="admin-page-title">Trainings</h1>
          </div>
        </div>
        <div class="admin-action-bar">
          <button type="button" class="admin-button--primary" @click="openCreateModal">
            Neues Training
          </button>
        </div>
      </div>
      <div class="w-full mt-2">
          <section class="admin-panel overflow-x-auto">
            <table class="w-full">
              <thead class="bg-gray-500 text-white sticky top-0 z-50">
                <tr>
                  <th class="py-3 px-4 font-semibold text-sm uppercase text-left">Name</th>
                  <th class="py-3 px-4 font-semibold text-sm uppercase text-left">Beschreibung</th>
                  <th class="py-3 px-4 font-semibold text-sm uppercase text-left">Gültig (Tage)</th>
                  <th class="py-3 px-4 font-semibold text-sm uppercase text-left">Dauer (Stunden)</th>
                  <th class="py-3 px-4 font-semibold text-sm uppercase text-left">Vorlage</th>
                  <th class="py-3 px-4 font-semibold text-sm uppercase text-left">Aktionen</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="training in trainings" :key="training.id" class="border-b border-gray-200 hover:bg-gray-50">
                  <td class="py-3 px-4">{{ training.name }}</td>
                  <td class="py-3 px-4">{{ training.description }}</td>
                  <td class="py-3 px-4">{{ training.validForDays }}</td>
                  <td class="py-3 px-4">{{ training.duration }}</td>
                  <td class="py-3 px-4">{{ getTemplateName(training.templateId) }}</td>
                  <td class="py-3 px-4">
                    <button type="button" class="admin-button--primary admin-button--sm mr-2" @click="openExecuteModal(training)">
                      Ausführen
                    </button>
                    <button type="button" class="admin-button--secondary admin-button--sm mr-2" @click="openEditModal(training)">
                      Bearbeiten
                    </button>
                    <button type="button" class="admin-button--danger admin-button--sm mr-2" @click="deleteTraining(training)">
                      Löschen
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="loading" class="text-center py-8">Lade Trainings...</div>
            <div v-else-if="trainings.length === 0" class="text-center py-8 text-gray-500">
              Keine Trainings vorhanden.
            </div>
          </section>
        </div>
        <!-- Create/Edit Modal -->
        <div v-if="showCreateModal || showEditModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div class="bg-white rounded-xl shadow-2xl p-8 w-full max-w-lg relative">
            <button type="button" class="admin-button--ghost admin-button--icon absolute top-2 right-4" aria-label="Schließen" @click="closeCreateEditModal">
              <i class="fa fa-xmark"></i>
            </button>
            <h2 class="text-xl font-bold mb-4">{{ showEditModal ? 'Training bearbeiten' : 'Neues Training erstellen' }}</h2>
            <form @submit.prevent="showEditModal ? saveEditTraining() : createTraining()">
              <div class="mb-4 text-left">
                <label class="block font-semibold mb-1">Name</label>
                <input v-model="editTraining.name" class="border rounded px-3 py-2 w-full" required />
              </div>
              <div class="mb-4 text-left">
                <label class="block font-semibold mb-1">Beschreibung</label>
                <textarea v-model="editTraining.description" class="border rounded px-3 py-2 w-full" required></textarea>
              </div>
              <div class="mb-4 text-left">
                <label class="block font-semibold mb-1">Gültig für (Tage)</label>
                <input type="number" v-model.number="editTraining.validForDays" class="border rounded px-3 py-2 w-full" required min="1" />
              </div>
              <div class="mb-4 text-left">
                <label class="block font-semibold mb-1">Dauer (Stunden)</label>
                <input type="number" v-model.number="editTraining.duration" class="border rounded px-3 py-2 w-full" required min="1" />
              </div>
              <div class="mb-4 text-left">
                <label class="block font-semibold mb-1">Vorlage</label>
                <select v-model="editTraining.templateId" class="border rounded px-3 py-2 w-full" required>
                  <option value="0">Keine</option>
                  <option v-for="tpl in templates" :value="tpl.id" :key="tpl.id">{{ tpl.name }}</option>
                </select>
              </div>
              <div class="flex justify-end gap-2 mt-6">
                <button type="button" class="admin-button--secondary" @click="closeCreateEditModal">Abbrechen</button>
                <button type="submit" class="admin-button--primary">{{ showEditModal ? 'Speichern' : 'Erstellen' }}</button>
              </div>
            </form>
          </div>
        </div>
        <ExecuteTrainingModal v-if="showExecuteModal" :templates="templates" :training="selectedTraining" @close="closeExecuteModal" @executed="showExecuteModal = false"/>
    </div>
  </div>
</template>

<script>
import CASP from '@/CASP.js';
import ExecuteTrainingModal from './ExecuteTrainingModal.vue';
export default {
  name: 'AdminTrainings',
  components:{ExecuteTrainingModal},
  data() {
    return {
      trainings: [],
      templates: [],
      employees: [],
      loading: true,
      showCreateModal: false,
      showEditModal: false,
      showExecuteModal: false,
      selectedTraining: null,
      selectedEmployees: [],
      sendViaMail: false,
      editTraining: {
        id: null,
        name: '',
        description: '',
        validForDays: 365,
        duration: 8,
        templateId: 0
      }
    };
  },
  methods: {
    fetchTrainings() {
      // Placeholder: Replace with actual CASP method
      this.loading = true;
      CASP.getTrainings((status, result) => {
        if(status == 200){
          this.trainings = result;
          this.loading = false;
        }
      });
    },
    fetchTemplates() {
      CASP.listTemplates((status, result) => {
        this.templates = result?.templates || [];
      });
    },
    getTemplateName(templateId) {
      const tpl = this.templates.find(t => t.id === templateId);
      return tpl ? tpl.name : '-';
    },
    openCreateModal() {
      this.editTraining = { id: null, name: '', description: '', validForDays: 30, duration: 8, templateId: 0 };
      this.showCreateModal = true;
    },
    openEditModal(training) {
      this.editTraining = { ...training };
      this.showEditModal = true;
    },
    closeCreateEditModal() {
      this.showCreateModal = false;
      this.showEditModal = false;
    },
    createTraining() {
      // Placeholder: Replace with actual CASP method
      CASP.addTraining(this.editTraining, (status, result) => {
        if (status == 200) {
          this.trainings.push(result);
          this.closeCreateEditModal();
        }
      });
    },
    saveEditTraining() {
      // Placeholder: Replace with actual CASP method
      CASP.updateTraining(this.editTraining.id, this.editTraining, (status, result) => {
        if (status == 200) {
          const idx = this.trainings.findIndex(t => t.id === this.editTraining.id);
          if (idx !== -1) this.trainings.splice(idx, 1, { ...this.editTraining });
          this.closeCreateEditModal();
        }
      });
    },
    deleteTraining(training) {
      // Placeholder: Replace with actual CASP method
      CASP.deleteTraining(training.id, (status, result) => {
        if (status == 200) {
          this.trainings = this.trainings.filter(t => t.id !== training.id);
        }
      });
    },
    openExecuteModal(training) {
      this.selectedTraining = training;
      this.selectedEmployees = [];
      this.sendViaMail = false;
      this.showExecuteModal = true;
    },
    closeExecuteModal() {
      this.showExecuteModal = false;
      this.selectedTraining = null;
      this.selectedEmployees = [];
      this.sendViaMail = false;
    },
    executeTraining() {
      // Placeholder: Replace with actual CASP method
      alert(`Training "${this.selectedTraining.name}" wird für Mitarbeiter ${this.selectedEmployees.join(', ')} ausgeführt. Per Mail: ${this.sendViaMail}`);
      this.closeExecuteModal();
    }
  },
  created() {
    this.fetchTrainings();
    this.fetchTemplates();
    document.getElementById("mainspinner").style.display = "none";
  }
};
</script>

<style scoped>
</style>
